__turbopack_context__.v({
  "description": "CheckoutDescription-module-scss-module__4qHMpq__description",
  "title": "CheckoutDescription-module-scss-module__4qHMpq__title",
  "titleGroup": "CheckoutDescription-module-scss-module__4qHMpq__titleGroup",
  "wrapper": "CheckoutDescription-module-scss-module__4qHMpq__wrapper",
});
